import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { debounce } from '../utils'
import { getAriaLabel } from '../a11y'
import { makeStyles , withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';


const classes = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',              /////340 to 380
    height: 37,
    backgroundColor: '#f3f6f9',
    borderRadius: '4px',
    border: 'solid 1px #ccd6e3'
  },
  input: {
    padding: "6px 25px 6px 0px",
    marginLeft: 2,
    flex: 1,
    lineHeight: '2em',
    minWidth: '95%',
    maxWidth: '100%'
  },
  iconButton: {
    padding: 4,
    marginLeft: 2
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

class Input extends PureComponent {
  static propTypes = {
    tags: PropTypes.array,
    texts: PropTypes.object,
    onInputChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onTagRemove: PropTypes.func,
    onKeyDown: PropTypes.func,
    inputRef: PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    activeDescendant: PropTypes.string,
    inlineSearchInput: PropTypes.bool,
    viewMode: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.delayedCallback = debounce(e => this.props.onInputChange(e.target.value), 300)
  }

  handleInputChange = e => {
    e.persist()
    this.delayedCallback(e)
  }

  render() {
    const {
      inputRef,
      texts = {},
      onFocus,
      onBlur,
      disabled,
      readOnly,
      onKeyDown,
      activeDescendant,
      inlineSearchInput,
      viewMode
    } = this.props


    if(viewMode=='full-mode'){
    return (
      <div className='mt-4 mb-4'><Paper className={this.props.classes.root} elevation={0}>
                <IconButton className={this.props.classes.iconButton} aria-label={'Search...'}>
                  <SearchIcon />
                </IconButton>
                <InputBase
                  className={this.props.classes.input}
                  placeholder={'Search...'}
                  inputProps={{ 'aria-label': 'Search...' }}
                 
                  disabled={disabled}
        ref={inputRef}
                  onKeyDown={onKeyDown}
        onChange={this.handleInputChange}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
                /></Paper></div>
    )
    }

    return (
      <input
      style={{}}
        type="text"
        disabled={disabled}
        ref={inputRef}
        className="search"
        placeholder={
          inlineSearchInput ? texts.inlineSearchPlaceholder || 'Search...' : texts.placeholder || 'Choose...'
        }
        onKeyDown={onKeyDown}
        onChange={this.handleInputChange}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
        aria-activedescendant={activeDescendant}
        aria-autocomplete={onKeyDown ? 'list' : undefined}
        {...getAriaLabel(texts.label)}
      />
    )
  }
}

export default withStyles(classes)(Input);
